import {
  getInstitution,
  getSelectedInstitution,
  setInstitutionId,
  setSelectedInstitution,
} from '@helpers/storageInstitution'
import { useAppDispatch, useSignalConsumer } from '@hooks'
import { Target } from '@src/hooks/useSignal'
import { updateUserSettings } from '@store/actions'
import { ReactNode, createContext } from 'react'

const defaultValue = {
  institution_id: getInstitution(),
  institution: getSelectedInstitution(),
  key: `institution_id=${getInstitution()}`,
  setInstitution: (option: { label: string; value: number }) => {},
}

export const UserSettingsContext = createContext(defaultValue)

type Props = {
  signal: Target<{
    institution_id: number
    institution: { label: string; value: number }
    key: string
  }>
  children?: ReactNode
}

export const UserSettingsProvider = ({ children, signal }: Props) => {
  const { state } = useSignalConsumer(signal)
  const dispatch = useAppDispatch()

  function setInstitution(option: { label: string; value: number }, lang?: 'uz' | 'en') {
    dispatch(
      updateUserSettings({
        institution_id: option?.value,
        locale: lang,
        onFulfilled: () => {
          setInstitutionId(option?.value)
          setSelectedInstitution(JSON.stringify(option))
          signal.value = {
            ...signal.value,
            institution_id: option?.value,
            institution: option,
            key: `institution_id=${option?.value}`,
          }
        },
      })
    )
  }

  return (
    <UserSettingsContext.Provider
      key={state.key}
      value={{
        institution_id: state.institution_id,
        institution: state.institution,
        setInstitution,
        key: state.key,
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  )
}
